<template>
  <span class="text-tag">
    <slot />
  </span>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '../../../css/import/vars';

.text-tag {
  font-size: 12px;
  line-height: 18px;

  &,
  a {
    color: $color-red;
    font-weight: 800;
    font-variation-settings: 'wght' 800;
    text-transform: uppercase;
  }

  @media all and (min-width: $screen-width-767) {
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
